import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import {
  getEmployeeDetailsData,
  updateEmployeeStatus,
} from "./Service/EmployeeExitService";
import { TostMsg } from "../../../App";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

function InitiateExitEmployeeDetails() {
  const [exitEmployeeList, setExitEmployeeList] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  useEffect(() => {
    getInitiateExitEmployeeData();
  }, []);

  async function getInitiateExitEmployeeData() {
    const params = {
      Id: 0,
      EmpId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
    };
    try {
      setIsloading(true);
      const data = await getEmployeeDetailsData(params);
      let exitemployeesDetails = await data;
      setExitEmployeeList(exitemployeesDetails?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function acceptEmployeeExitLater(type) {
    let withdrawType = exitEmployeeList[0]?.IsWithdraw;
    let isFeedBackType = exitEmployeeList[0]?.IsExitFeedback;
    let isAccept = exitEmployeeList[0]?.IsAccept;
    let isDecline = exitEmployeeList[0]?.IsDecline;
    if (type == "withdrawType") {
      withdrawType = true;
    } else if (type == "exitFeedbackType") {
      isFeedBackType = true;
    }
    try {
      const params = {
        Id: exitEmployeeList[0]?.Id,
        IsAccept: isAccept,
        IsWithdraw: withdrawType,
        IsDecline: isDecline,
        IsFeedback: isFeedBackType,
      };
      await updateEmployeeStatus(params);
      getInitiateExitEmployeeData();
      GetMasterSystemAlertList("Status Updated");
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    } finally {
      setIsloading(false);
    }
  }

  async function GetMasterSystemAlertList(message) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message) {
        toster.current.success(msg?.Desc);
      }
    });
  }

  return (
    <div className="container position-relation">
      <div className="row">
        <div className="form-head d-flex flex-wrap align-items-center">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={25}
                height={25}
                fill="currentColor"
                className="bi bi-gear mr-3"
                viewBox="0 0 16 16"
                style={{ color: "#f44336" }}
              >
                <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"></path>
                <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"></path>
              </svg>
              Initiate Exit Detail
            </h2>
            {/* <p className="text-light">Lorem ipisuh shdnjn</p> */}
          </div>
          <div className="rightside-tabs">
            <div className="me-auto">
              <div>
                <ul>
                  <li className="nav-item dropdown notification_dropdown">
                    <Link
                      to={`/AddInitiateExitEmployee`}
                      className="nav-link p-0 cssa"
                      href="initiate-exit-step1.html"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="Back"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={25}
                        height={25}
                        fill="currentColor"
                        className="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                        />
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="edit-ticket mt-4 mb-4">
          <div className="w-100">
            <div className="row">
              <div className="col-md-8">
                <div className="employee-card tile-grid tile-grid-v1">
                  <div id="feed-post-1" className="supp-req">
                    <div className="third-section">
                      {exitEmployeeList?.length > 0 ? (
                        <div className="card">
                          <div className="card-body ">
                            <div className="more-jobdetail">
                              <strong
                                classname
                                style={{ position: "relative" }}
                              >
                                Email Address
                                <p className="fw-100">
                                  {exitEmployeeList[0]?.EmployeeEmail}
                                </p>
                              </strong>
                              <strong
                                classname
                                style={{ position: "relative" }}
                              >
                                Contact
                                <p className="fw-100">
                                  {exitEmployeeList[0]?.Id}{" "}
                                </p>
                              </strong>
                              <strong
                                classname
                                style={{ position: "relative" }}
                              >
                                Initiated date
                                <p className="fw-100">
                                  {moment(
                                    exitEmployeeList[0]?.InitiatedDate
                                  ).format("MMM DD YYYY")}
                                </p>
                              </strong>
                              <strong
                                classname
                                style={{ position: "relative" }}
                              >
                                Last working date
                                <p className="fw-100">
                                  {moment(
                                    exitEmployeeList[0]?.InitiatedDate
                                  ).format("MMM DD YYYY")}
                                </p>
                              </strong>
                              <strong
                                classname
                                style={{ position: "relative" }}
                              >
                                Reporting Manger{" "}
                                <p className="fw-100">
                                  {exitEmployeeList[0]?.ReportingManager}
                                </p>
                              </strong>
                              <strong
                                classname
                                style={{ position: "relative" }}
                              >
                                Human Resource Manager
                                <p className="fw-100">
                                  {exitEmployeeList[0]?.HRManager}
                                </p>
                              </strong>
                            </div>
                            <div className="col-md-12">
                              <div>
                                {exitEmployeeList[0]?.IsWithdraw == true && (
                                  <span className="high-pri">Withdrawn</span>
                                )}
                              </div>
                              {exitEmployeeList[0]?.IsExitFeedback == true && (
                                <span className="low-pri">Exit Feedback</span>
                              )}
                            </div>
                            <div
                              className="col-md-12"
                              style={{ textAlign: "end" }}
                            >
                              <div>
                                {exitEmployeeList[0]?.IsWithdraw == false && (
                                  <button
                                    onClick={() =>
                                      acceptEmployeeExitLater("withdrawType")
                                    }
                                    type="submit"
                                    className="savebtn-click"
                                  >
                                    Withdraw
                                  </button>
                                )}
                                {exitEmployeeList[0]?.IsExitFeedback ==
                                  false && (
                                  <button
                                    className="publish-click"
                                    onClick={() =>
                                      acceptEmployeeExitLater(
                                        "exitFeedbackType"
                                      )
                                    }
                                  >
                                    Exit Feedback
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="card">
                          <div className="card-body ">
                            No exit details found.
                          </div>
                        </div>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="side-add-section">
                  <div className="has-background-image">
                    <div className="initiate-exithistory text-left">
                      <h4 className="how-it mb-4">History</h4>
                      {exitEmployeeList[0]?.WithdrawnStatus.length > 0 ? (
                        <div className="icon-timeline">
                          <div className="timeline-item">
                            <div className="timeline-icon is-squared">
                              <LazyImage
                                className="avatar"
                                src={exitEmployeeList[0]?.ProfileImage}
                              />
                            </div>
                            {exitEmployeeList[0]?.HRStatus && (
                              <div className="timeline-content">
                                <p>{exitEmployeeList[0]?.HRStatus}</p>
                                <span>
                                  {moment(
                                    exitEmployeeList[0]?.ModifiedDate
                                  ).format("MMM DD YYYY")}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="timeline-item-end">
                            <div className="timeline-icon is-squared">
                              <LazyImage
                                className="avatar"
                                src={exitEmployeeList[0]?.ProfileImage}
                              />
                            </div>
                            {exitEmployeeList[0]?.WithdrawnStatus && (
                              <div
                                className="timeline-content"
                                style={{
                                  borderLeft: "0px solid #20202029 !important",
                                }}
                              >
                                <p>{exitEmployeeList[0]?.WithdrawnStatus}</p>
                                <span>
                                  {moment(
                                    exitEmployeeList[0]?.CreatedDate
                                  ).format("MMM DD YYYY")}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <p>No data found.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}

export default InitiateExitEmployeeDetails;
